import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { getProductPriceLabel } from "src/helpers/productLabels";
import { type PublicProfilePageProduct } from "src/pages/PublicProfilePage";
import { type ProfileTheme } from "src/profile/profileDesign";

interface PublicProfileProductCardProps {
  coachSlug: string;
  product: PublicProfilePageProduct;
  theme: ProfileTheme;
}

export function PublicProfileProductCard(props: PublicProfileProductCardProps) {
  const { t } = useTranslation();
  const { product } = props;
  const priceLabels = product.prices.map((price) => {
    return getProductPriceLabel(t, price);
  });

  return (
    <Link
      to="/c/$slug/p/$productSlug"
      params={{ slug: props.coachSlug, productSlug: product.slug }}
      className="flex items-center gap-3 rounded-xl px-4 py-3 shadow-sm ring-1 ring-black/[0.06]"
      style={{
        backgroundColor: props.theme.buttonColor,
        color: props.theme.buttonTextColor,
      }}
    >
      {product.imageUrl ? (
        <img
          src={product.imageUrl}
          alt=""
          className="size-12 shrink-0 rounded-lg object-cover"
        />
      ) : null}
      <span className="flex min-w-0 flex-1 flex-col gap-0.5 text-left">
        <span className="truncate text-sm font-medium">{product.name}</span>
        <span className="text-xs opacity-70">{priceLabels.join(" · ")}</span>
      </span>
    </Link>
  );
}
